import { render } from "./DiskPerformanceOptions.vue?vue&type=template&id=1210282b&scoped=true"
import script from "./DiskPerformanceOptions.vue?vue&type=script&lang=js"
export * from "./DiskPerformanceOptions.vue?vue&type=script&lang=js"

import "./DiskPerformanceOptions.vue?vue&type=style&index=0&id=1210282b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1210282b"]])

export default __exports__